import HTTP from '@/api/HTTP';
import { CATEGORIE_UNITAIRE, CATEGORIE_DIVERS } from '@/configurations/configPanneau';

const URL_BASE = 'gescom/LigneCommandeAnonyme/';

export async function PGetAllAnonymeRecapBudgetAsync(hash, query) {
  const dataQuery = {
    ...query,
    etatsDevisCommandeFacture: ['Enregistre', 'Facture', 'FactureePartiellement', 'Commande'],
    categorieVente: [CATEGORIE_UNITAIRE, CATEGORIE_DIVERS],
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllAnonymeRecapBudgetAsync', {
    query: dataQuery,
    sorting: '',
    skipCount: 0,
    maxResultCount: 999999,
  }, { params: { hash } });
  return response;
}

export async function PGetAllAnonymeParPdvAsync(hash, Query) {
  const dataQuery = {
    ...Query.query,
    etatsDevisCommandeFacture: ['Enregistre', 'Facture', 'FactureePartiellement', 'Commande'],
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllAnonymeParPdvAsync', {
    query: dataQuery,
    sorting: Query.sorting || '',
    skipCount: (Query.page - 1) * Query.limit,
    maxResultCount: Query.limit,
  }, { params: { hash } });
  return response;
}

export async function PGetAllLigneAnonymeByProduitIdAsync(hash, Query) {
  const dataQuery = {
    ...Query.query,
    typesDevisCommandeFacture: ['Commande'],
    etatsDevisCommandeFacture: ['Enregistre', 'Facture', 'FactureePartiellement', 'Commande'],
  };
  // FV
  const response = await HTTP.post(URL_BASE + 'PGetAllLigneAnonymeByProduitIdAsync', {
    query: dataQuery,
    sorting: '',
    skipCount: 0,
    maxResultCount: Query.maxResultCount,
  }, { params: { hash } });
  return response;
}
